// EconomicInfo.jsx
import React, { useState, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { getEconomicIndicators } from '../../services/economicAPI';

const EconomicInfo = () => {
  const [economicData, setEconomicData] = useState({
    uf: null,
    dollar: null,
    date: "",
    loading: true,
    error: null
  });

  useEffect(() => {
    let isMounted = true;
    
    const fetchData = async () => {
      try {
        const data = await getEconomicIndicators();
        
        if (isMounted) {
          setEconomicData({
            ...data,
            loading: false,
            error: null
          });
        }
      } catch (error) {
        if (isMounted) {
          setEconomicData(prev => ({
            ...prev,
            loading: false,
            error: "No se pudieron cargar los datos económicos."
          }));
        }
      }
    };

    fetchData();
    
    return () => {
      isMounted = false;
    };
  }, []);

  const { uf, dollar, date, loading, error } = economicData;
  
  if (error) {
    return (
      <div className="w-full bg-[#09274A] text-white text-center py-3 flex justify-center items-center">
        <ErrorOutlineIcon sx={{ marginRight: 1 }} />
        <span>Error: {error}</span>
      </div>
    );
  }
  
  return (
    <div className="w-full bg-[#09274A] text-white text-center py-3 flex justify-center items-center space-x-6 md:flex-row flex-col text-base">
      {loading ? (
        <div className="flex items-center">
          <CircularProgress size={20} sx={{ color: 'white', marginRight: 2 }} />
          <span>Cargando indicadores económicos...</span>
        </div>
      ) : (
        <>
          {date && <p className="text-lg">📅 {date}</p>}
          {uf && dollar && (
            <p className="text-lg">
              💰 UF: {uf.toLocaleString("es-CL")} CLP | 💲 Dólar: {dollar.toLocaleString("es-CL")} CLP
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default React.memo(EconomicInfo);